import React, { useState } from 'react'

import UserBoardMain from './Main'
import UserBoardFeed from './Aside/Feed'

import './styles.scss'

const bc = 'user-board'

const UserBoard = () => {
  const [height, setHeight] = useState(380)
  return (
    <div className={bc} id={bc}>
      <UserBoardMain setHeight={setHeight} />
      <UserBoardFeed height={height} />
    </div>
  )
}

export default UserBoard
